import { Route } from 'react-router-dom'
import { PlatformApp } from '@quoter/web-core'
import { AppLayout } from '@/components/AppLayout'
import { Today } from '@/routes/Today'
import { Foods } from '@/routes/Foods'
import { Plan } from '@/routes/Plan'
import { Settings } from '@/routes/Settings'
import { PublicTable } from '@/routes/PublicTable'
import { ConsentGate } from '@/components/ConsentGate'

/**
 * LowFodmaps's screens. Sign-in, pricing, paywall, checkout returns and the 404
 * come from PlatformApp; the routes below render inside the guarded layout.
 * /table is the exception: the food table for anyone, no account needed.
 *
 * The two screens that store what the person eats and feels sit behind the
 * consent gate; the food table and Settings store nothing and do not.
 */
export function App() {
  return (
    <PlatformApp layout={<AppLayout />} publicRoutes={<Route path="/table" element={<PublicTable />} />}>
      <Route
        index
        element={
          <ConsentGate>
            <Today />
          </ConsentGate>
        }
      />
      <Route path="foods" element={<Foods />} />
      <Route
        path="plan"
        element={
          <ConsentGate>
            <Plan />
          </ConsentGate>
        }
      />
      <Route path="settings" element={<Settings />} />
    </PlatformApp>
  )
}
